import { Injectable } from "@angular/core";
import { Message } from "./message.model";
import {BehaviorSubject, Observable} from "rxjs";
@Injectable()
export class MessageService {
    private subject = new BehaviorSubject<Message>(new Message("",false));
    reportMessage(msg: Message) {

        this.subject.next(msg);

    }

    get messages(): Observable<Message> {
        return this.subject;
    }
}
